module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('doc-section', {
    attrs: {
      "id": "button-group",
      "name": "Button Group"
    }
  }, [_vm._c('div', {
    staticClass: "bs-example"
  }, [_vm._c('h4', [_vm._v("Checkbox")]), _vm._v(" "), _vm._c('button-group', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checkboxValue),
      expression: "checkboxValue"
    }],
    domProps: {
      "value": (_vm.checkboxValue)
    },
    on: {
      "input": function($event) {
        _vm.checkboxValue = $event
      }
    }
  }, [_vm._c('checkbox', {
    attrs: {
      "true-value": "left"
    }
  }, [_vm._v("Left")]), _vm._v(" "), _vm._c('checkbox', {
    attrs: {
      "true-value": "middle"
    }
  }, [_vm._v("Middle")]), _vm._v(" "), _vm._c('checkbox', {
    attrs: {
      "true-value": "right"
    }
  }, [_vm._v("Right")])], 1), _vm._v(" "), _vm._c('p', [_vm._c('pre', [_vm._v("Checkbox value: " + _vm._s(_vm.checkboxValue))])]), _vm._v(" "), _vm._c('hr'), _vm._v(" "), _vm._c('h4', [_vm._v("Radio")]), _vm._v(" "), _vm._c('p', [_vm._c('button-group', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.radioValue),
      expression: "radioValue"
    }],
    attrs: {
      "type": "primary"
    },
    domProps: {
      "value": (_vm.radioValue)
    },
    on: {
      "input": function($event) {
        _vm.radioValue = $event
      }
    }
  }, [_vm._c('radio', {
    attrs: {
      "selected-value": "left"
    }
  }, [_vm._v("Left")]), _vm._v(" "), _vm._c('radio', {
    attrs: {
      "selected-value": "middle"
    }
  }, [_vm._v("Middle")]), _vm._v(" "), _vm._c('radio', {
    attrs: {
      "selected-value": "right"
    }
  }, [_vm._v("Right")])], 1)], 1), _vm._v(" "), _vm._c('p', [_vm._c('button-group', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.radioValue),
      expression: "radioValue"
    }],
    attrs: {
      "type": "success"
    },
    domProps: {
      "value": (_vm.radioValue)
    },
    on: {
      "input": function($event) {
        _vm.radioValue = $event
      }
    }
  }, [_vm._c('radio', {
    attrs: {
      "selected-value": "left"
    }
  }, [_vm._v("Left")]), _vm._v(" "), _vm._c('radio', {
    attrs: {
      "selected-value": "middle"
    }
  }, [_vm._v("Middle")]), _vm._v(" "), _vm._c('radio', {
    attrs: {
      "selected-value": "right"
    }
  }, [_vm._v("Right")])], 1)], 1), _vm._v(" "), _vm._c('p', [_vm._c('label', [_vm._v("Not buttons:")]), _vm._v(" "), _vm._c('button-group', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.radioValue),
      expression: "radioValue"
    }],
    attrs: {
      "type": "info",
      "buttons": false
    },
    domProps: {
      "value": (_vm.radioValue)
    },
    on: {
      "input": function($event) {
        _vm.radioValue = $event
      }
    }
  }, [_vm._c('radio', {
    attrs: {
      "selected-value": "left"
    }
  }, [_vm._v("Left")]), _vm._v(" "), _vm._c('radio', {
    attrs: {
      "selected-value": "middle"
    }
  }, [_vm._v("Middle")]), _vm._v(" "), _vm._c('radio', {
    attrs: {
      "selected-value": "right"
    }
  }, [_vm._v("Right")])], 1)], 1), _vm._v(" "), _vm._c('p', [_vm._c('pre', [_vm._v("Radio value: " + _vm._s(_vm.radioValue))])])], 1), _vm._v(" "), _vm._c('doc-code', {
    attrs: {
      "language": "markup"
    }
  }, [_vm._v("\n    <button-group v-model=\"checkboxValue\">\n      <checkbox true-value=\"left\">Left</checkbox>\n      <checkbox true-value=\"middle\">Middle</checkbox>\n      <checkbox true-value=\"right\">Right</checkbox>\n    </button-group>\n\n    <button-group v-model=\"radioValue\" type=\"primary\">\n      <radio selected-value=\"left\">Left</radio>\n      <radio selected-value=\"middle\">Middle</radio>\n      <radio selected-value=\"right\">Right</radio>\n    </button-group>\n\n    Not Buttons:\n    <button-group v-model=\"radioValue\" type=\"info\" buttons=\"false\">\n      <radio selected-value=\"left\">Left</radio>\n      <radio selected-value=\"middle\">Middle</radio>\n      <radio selected-value=\"right\">Right</radio>\n    </button-group>\n  ")]), _vm._v(" "), _vm._c('doc-table', [_vm._c('div', [_vm._c('p', [_vm._v("value")]), _vm._v(" "), _vm._c('p', [_vm._c('code', [_vm._v("Array")]), _vm._v(" or "), _vm._c('code', [_vm._v("String")])]), _vm._v(" "), _vm._c('p'), _vm._v(" "), _vm._c('p', [_vm._v("If defined, then the defined values will be checked otherwise the elements with a checked attribute\n      will be checked.")])]), _vm._v(" "), _vm._c('div', [_vm._c('p', [_vm._v("buttons")]), _vm._v(" "), _vm._c('p', [_vm._c('code', [_vm._v("Boolean")])]), _vm._v(" "), _vm._c('p', [_vm._c('code', [_vm._v("true")])]), _vm._v(" "), _vm._c('p'), _vm._c('p', [_vm._v("Can enable/disable button style.")]), _vm._v(" "), _vm._c('p', [_vm._v("Group normal checks if you want to set the same type color for all.")]), _vm._v(" "), _vm._c('p')]), _vm._v(" "), _vm._c('div', [_vm._c('p', [_vm._v("disabled")]), _vm._v(" "), _vm._c('p', [_vm._c('code', [_vm._v("Boolean")])]), _vm._v(" "), _vm._c('p', [_vm._c('code', [_vm._v("false")])]), _vm._v(" "), _vm._c('p'), _vm._c('p', [_vm._v("Can enable/disable group values.")]), _vm._v(" "), _vm._c('p', [_vm._v("Disable it if you need independent values but want to group color and/or style.")]), _vm._v(" "), _vm._c('p')]), _vm._v(" "), _vm._c('div', [_vm._c('p', [_vm._v("type")]), _vm._v(" "), _vm._c('p', [_vm._c('code', [_vm._v("String")]), _vm._v(", one of "), _vm._c('code', [_vm._v("default")]), _vm._v(" "), _vm._c('code', [_vm._v("primary")]), _vm._v(" "), _vm._c('code', [_vm._v("danger")]), _vm._v(" "), _vm._c('code', [_vm._v("info")]), _vm._v(" "), _vm._c('code', [_vm._v("warning")]), _vm._v(" "), _vm._c('code', [_vm._v("success")])]), _vm._v(" "), _vm._c('p', [_vm._c('code', [_vm._v("default")])]), _vm._v(" "), _vm._c('p')])])], 1)
},staticRenderFns: []}
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4ba9927e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4ba9927e!./~/vue-loader/lib/selector.js?type=template&index=0!./docs/example/buttonGroupDocs.vue
// module id = 149
// module chunks = 0